'use client'

import { memo, Suspense, useContext, useState } from 'react'
import Link from 'next/link'
import ExpandButton from '@dustin-web/microsite-components/src/expand-button'
import { useTranslations } from '@dustin-web/microsite-components/src/hooks'
import { Skeleton } from '@dustin-web/microsite-components/src/skeleton'
import type { Product } from '@productsite-beta/src/graphql/generated/graphql-types'
import { scrollToTabs } from '../../product-page.utils'
import { AttachedSalesContext } from '../components/attached-sales-provider'
import ProductCard from './product-card/product-card'

import './product-cross-sell.scss'

type Props = {
  mainProductTicket: string
  isMobile: boolean
  pathName: string
}

const ProductCrossSell = ({ mainProductTicket, isMobile, pathName }: Props) => {
  const [showAll, setshowAll] = useState(false)
  const { translate } = useTranslations()
  const { list, handleIsSelected } = useContext(AttachedSalesContext)

  const initalProductCount = isMobile ? 1 : 2
  const products = showAll ? list : list.slice(0, initalProductCount)
  const viewAllAccessoriesLink = pathName + '?tab=accessories'

  const toggleShowAll = () => {
    setshowAll(state => !state)
  }

  return (
    <div className="product-cross-sell">
      <div className="header">
        <h2 className="h4">{translate('Product_CrossSell_AttachedSales_Header')}</h2>
        <Link
          data-testid="accessories-view-all-link"
          scroll={false}
          onClick={scrollToTabs}
          href={viewAllAccessoriesLink}>
          {translate('Product_CrossSell_AttachedSales_View_All')}
        </Link>
      </div>
      <div className="products-wrapper">
        <Suspense
          fallback={Array.from({ length: initalProductCount }).map((_, index) => {
            return <Skeleton key={index} height={isMobile ? 116 : 69} />
          })}>
          {products?.map((productData, key) => (
            <ProductCard
              key={key}
              digitalIndex={key}
              handleCheckbox={() => handleIsSelected(productData.product.productErpIdentifier)}
              isSelected={productData.isSelected}
              product={productData.product as Product}
              isSmallScreen={isMobile}
              ticket={mainProductTicket}
              digitalDataOrigin="productPageAttach"
            />
          ))}
        </Suspense>
      </div>
      {list?.length > initalProductCount && (
        <ExpandButton
          className="u-pt-12"
          onClick={toggleShowAll}
          collapsedTitle={translate('ShowMore')}
          expandedTitle={translate('ShowLess')}
          expanded={showAll}
          ariaControls="expandable-cross-sell-cards"
        />
      )}
    </div>
  )
}

export default memo(ProductCrossSell)
